import { render, staticRenderFns } from "./BaseLoadingBar.vue?vue&type=template&id=168d8252"
import script from "./BaseLoadingBar.vue?vue&type=script&lang=js"
export * from "./BaseLoadingBar.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingBar.vue?vue&type=style&index=0&id=168d8252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports